/**
 * Tutorial step definitions for the in-app onboarding walkthrough.
 *
 * Each step may have:
 *   • anchor: a data-testid present on the current page. If found, the
 *     overlay draws a ring around it. If not found, the card is centered.
 *   • page:   route to push (string) OR "auto" (no navigation).
 *   • title + body + icon key
 *
 * We keep the steps light on navigation — the tutorial is primarily a
 * soft intro. Users click "Next" through 6 screens; if anchors are
 * unavailable on the current route, each step falls back to a centered
 * card so it still works on any page.
 */
export const TUTORIAL_STEPS = [
  {
    id: "property",
    title: "Step 1 · Create a property",
    body: "A property is an apartment complex, office building, or lot you manage. Create one to start adding tenants and vehicles.",
    anchor: "dashboard-add-tenant", // or create-first-property
    icon: "Building2",
  },
  {
    id: "tenant-vehicle",
    title: "Step 2 · Add tenants & vehicles",
    body: "Use the Add Tenant wizard to register a resident and their vehicle. The 2nd+ vehicle in the same unit is FREE.",
    anchor: "dashboard-add-tenant",
    icon: "Users",
  },
  {
    id: "activate",
    title: "Step 3 · Activate the QR code",
    body: "Activating a QR makes it scannable and adds $1.00/mo to your bill (per active car). You'll need to pay the $99 setup fee first — your first 30 days are free.",
    anchor: "stat-active_vehicles",
    icon: "QrCode",
  },
  {
    id: "stickers",
    title: "Step 4 · Print & stick",
    body: "Each activated vehicle gets a unique QR sticker. Place it in the windshield, upper-right corner. Order packs from the Stickers page.",
    anchor: null,
    icon: "Sticker",
  },
  {
    id: "scan",
    title: "Step 5 · Scan & verify",
    body: "Security or staff scan the sticker with any phone camera. The public scan page shows the vehicle, unit, and status instantly — no login needed.",
    anchor: null,
    icon: "ScanLine",
  },
  {
    id: "billing",
    title: "Step 6 · Billing",
    body: "$99 one-time setup, then $1.00 per active car / month. First 30 days FREE after setup. Volume discounts at 200/500 cars; 1000+ is a custom quote.",
    anchor: "stat-monthly_total",
    icon: "DollarSign",
  },
];

/** Local-storage key to remember dismissed state in case backend is slow. */
export const TUTORIAL_LS_KEY = "scanmint_tutorial_completed";
